import { IBlobFile } from "../models/blob-file";
import FileDownload from 'js-file-download';

export class FileDownloadUtility {

    public static downloadbase64StringToBrowser(base64String: string, filename: string): void {
    if (!base64String || base64String.length === 0) {
        return;
    }

      const blobData = base64ToByteArray(base64String);
      const mimeType = getMimeTypeFromFilename(filename);

      const arrayBuffer = blobData.buffer as ArrayBuffer;
      const blobObject = new Blob(
          [arrayBuffer.slice(blobData.byteOffset, blobData.byteOffset + blobData.byteLength)],
          { type: mimeType }
      );

      FileDownload(blobObject, filename, mimeType);

      return;
  }

    public static downloadBlobToBrowser(blob: IBlobFile): void {
        let fileName: string = '';

        if(blob?.overview !== null) {
            //fileName = blob.overview.metadata?.FileName??
            fileName = blob.overview.metadata?.filename??
                        blob.overview.blobName;
        }
        this.downloadbase64StringToBrowser(blob.blobContent, fileName);
        return;
    }
}

function base64ToByteArray(base64: string): Uint8Array {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes;
}

function getMimeTypeFromFilename(fileName: string) : string {
    let mimeType = '';

    if (!fileName || fileName.length === 0) {
        return '';
    }

    const fileExtension = fileName.split('.').pop();

    if (fileExtension === 'pdf') {
        mimeType = 'application/pdf';
    } else if (fileExtension === 'mp4') {
        mimeType = 'video/mp4';
    } else {
        mimeType = '';
    }

    return mimeType;
}
